// extracted by mini-css-extract-plugin
export var mediaElement = "mockup-ipad-module--mediaElement--83104";
export var mockImage = "mockup-ipad-module--mockImage--683e1";
export var mockup = "mockup-ipad-module--mockup--800ee";